import { render, staticRenderFns } from "./TableDynamicFields.vue?vue&type=template&id=bdb4142a"
import script from "./TableDynamicFields.vue?vue&type=script&lang=js"
export * from "./TableDynamicFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports